"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onClickLaunchApp = exports.onClickLaunch = exports.onClickJoinForDetail = exports.onClickJoinForPmi = exports.isWxWorkGte312 = void 0;
var tslib_1 = require("tslib");
var web_base_1 = require("@tencent/web-base");
var enum_1 = require("../../enum");
var get_scheme_1 = require("./get-scheme");
var launch_app_1 = require("./launch-app");
var launch_callback_1 = require("./launch-callback");
var tx_weixin_jsbridge_1 = require("./tx-weixin-jsbridge");
var tx_wxwork_jsbridge_1 = require("./tx-wxwork-jsbridge");
var init_aegis_1 = tslib_1.__importDefault(require("../../_util/init-aegis"));
// TODO
var IS_I18N = process.env.IS_I18N === 'true';
/**
 * 企业微信版本是否大于3.1.2
 */
var isWxWorkGte312 = function () {
    var userAgent = window.navigator.userAgent;
    var wxInfo = userAgent.match(/wxwork\/([\d.]+)/i);
    return (userAgent.includes('wxwork')
        && wxInfo
        && wxInfo.length >= 2
        && (0, web_base_1.compareVersion)(wxInfo[1], '3.1.2') >= 0);
};
exports.isWxWorkGte312 = isWxWorkGte312;
/**
 * Pmi会议使用
 * @param type
 * @param meetingCode
 * @param meetingState
 * @param meetingType
 * @param joinToken
 * @param initLaunchRes
 * @param countryCode
 * @param showDetail
 * @param showDownload
 * @param uninstallCb
 */
var onClickJoinForPmi = function (pmiProps) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var _a, type, duration, meetingCode, meetingState, meetingType, joinToken, initLaunchRes, _b, countryCode, customScheme, meetingId, showDetail, showDownload, uninstallCb, beaconReport, wxLaunchFailedCallback, queryLaunchTimeout, http, wx, aegis, _c, from, rs;
    return tslib_1.__generator(this, function (_d) {
        _a = pmiProps.type, type = _a === void 0 ? enum_1.EnumLaunchType.MeetingCode : _a, duration = pmiProps.duration, meetingCode = pmiProps.meetingCode, meetingState = pmiProps.meetingState, meetingType = pmiProps.meetingType, joinToken = pmiProps.joinToken, initLaunchRes = pmiProps.initLaunchRes, _b = pmiProps.countryCode, countryCode = _b === void 0 ? 'cn' : _b, customScheme = pmiProps.customScheme, meetingId = pmiProps.meetingId, showDetail = pmiProps.showDetail, showDownload = pmiProps.showDownload, uninstallCb = pmiProps.uninstallCb, beaconReport = pmiProps.beaconReport, wxLaunchFailedCallback = pmiProps.wxLaunchFailedCallback, queryLaunchTimeout = pmiProps.queryLaunchTimeout, http = pmiProps.http, wx = pmiProps.wx, aegis = pmiProps.aegis, _c = pmiProps.from, from = _c === void 0 ? '' : _c, rs = pmiProps.rs;
        (0, exports.onClickLaunch)(true, function () { return (0, launch_callback_1.installCallback)({
            type: type,
            duration: duration,
            meetingCode: meetingCode,
            meetingState: meetingState,
            meetingType: meetingType,
            joinToken: joinToken,
            initLaunchRes: initLaunchRes,
            showDetail: showDetail,
            uninstallCb: uninstallCb,
            customScheme: customScheme,
            meetingId: meetingId,
            showDownload: showDownload,
            beaconReport: beaconReport,
            wxLaunchFailedCallback: wxLaunchFailedCallback,
            http: http,
            aegis: aegis,
            from: from,
            rs: rs,
        }); }, function () { return (0, launch_callback_1.uninstallCallback)({ type: type, meetingCode: meetingCode, meetingState: meetingState, showDownload: showDownload, countryCode: countryCode, uninstallCb: uninstallCb }); }, function () {
            (0, launch_callback_1.installCallback)({
                type: type,
                duration: duration,
                meetingCode: meetingCode,
                meetingState: meetingState,
                meetingType: meetingType,
                joinToken: joinToken,
                initLaunchRes: initLaunchRes,
                showDetail: showDetail,
                uninstallCb: uninstallCb,
                customScheme: customScheme,
                meetingId: meetingId,
                showDownload: showDownload,
                beaconReport: beaconReport,
                wxLaunchFailedCallback: wxLaunchFailedCallback,
                queryLaunchTimeout: queryLaunchTimeout,
                http: http,
                aegis: aegis,
                from: from,
                rs: rs,
            });
            showDownload(type);
        }, initLaunchRes, wx, wxLaunchFailedCallback);
        return [2 /*return*/];
    });
}); };
exports.onClickJoinForPmi = onClickJoinForPmi;
/**
 * 分享详情页使用
 * @param type
 * @param meetingCode
 * @param meetingState
 * @param meetingType
 * @param joinToken
 * @param initLaunchRes
 * @param countryCode
 * @param showDetail
 * @param showDownload
 * @param uninstallCb
 */
var onClickJoinForDetail = function (detailProps) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var _a, type, duration, meetingCode, meetingState, meetingType, joinToken, initLaunchRes, _b, countryCode, customScheme, meetingId, _c, showDetail, _d, showDownload, uninstallCb, mode, beaconReport, wxLaunchFailedCallback, queryLaunchTimeout, _e, http, wx, aegis, _f, from, rs, joinMode, launchMode;
    return tslib_1.__generator(this, function (_g) {
        switch (_g.label) {
            case 0:
                _a = detailProps.type, type = _a === void 0 ? enum_1.EnumLaunchType.LaunchApp : _a, duration = detailProps.duration, meetingCode = detailProps.meetingCode, meetingState = detailProps.meetingState, meetingType = detailProps.meetingType, joinToken = detailProps.joinToken, initLaunchRes = detailProps.initLaunchRes, _b = detailProps.countryCode, countryCode = _b === void 0 ? 'cn' : _b, customScheme = detailProps.customScheme, meetingId = detailProps.meetingId, _c = detailProps.showDetail, showDetail = _c === void 0 ? function () { return void 0; } : _c, _d = detailProps.showDownload, showDownload = _d === void 0 ? function () { return void 0; } : _d, uninstallCb = detailProps.uninstallCb, mode = detailProps.mode, beaconReport = detailProps.beaconReport, wxLaunchFailedCallback = detailProps.wxLaunchFailedCallback, queryLaunchTimeout = detailProps.queryLaunchTimeout, _e = detailProps.http, http = _e === void 0 ? {
                    post: function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
                        return [2 /*return*/, void 0];
                    }); }); },
                    get: function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
                        return [2 /*return*/, void 0];
                    }); }); },
                } : _e, wx = detailProps.wx, aegis = detailProps.aegis, _f = detailProps.from, from = _f === void 0 ? '' : _f, rs = detailProps.rs;
                joinMode = mode || 0;
                launchMode = detailProps.launchMode || enum_1.EnumLaunchMode.NotValid;
                return [4 /*yield*/, (0, exports.onClickLaunch)(!launchMode && !joinMode, function () { return (0, launch_callback_1.installCallback)({
                        type: type,
                        duration: duration,
                        meetingCode: meetingCode,
                        meetingState: meetingState,
                        meetingType: meetingType,
                        joinToken: joinToken,
                        initLaunchRes: initLaunchRes,
                        showDetail: showDetail,
                        uninstallCb: uninstallCb,
                        customScheme: customScheme,
                        meetingId: meetingId,
                        showDownload: showDownload,
                        beaconReport: beaconReport,
                        wxLaunchFailedCallback: wxLaunchFailedCallback,
                        http: http,
                        aegis: aegis,
                        from: from,
                        rs: rs,
                    }); }, 
                    // eslint-disable-next-line @typescript-eslint/no-misused-promises
                    function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, (0, launch_callback_1.uninstallCallback)({ type: type, meetingCode: meetingCode, meetingState: meetingState, showDownload: showDownload, countryCode: countryCode, uninstallCb: uninstallCb })];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    }); }); }, function () {
                        (0, launch_callback_1.installCallback)({
                            type: type,
                            duration: duration,
                            meetingCode: meetingCode,
                            meetingState: meetingState,
                            meetingType: meetingType,
                            joinToken: joinToken,
                            initLaunchRes: initLaunchRes,
                            showDetail: showDetail,
                            uninstallCb: uninstallCb,
                            customScheme: customScheme,
                            meetingId: meetingId,
                            showDownload: showDownload,
                            beaconReport: beaconReport,
                            wxLaunchFailedCallback: wxLaunchFailedCallback,
                            queryLaunchTimeout: queryLaunchTimeout,
                            http: http,
                            aegis: aegis,
                            from: from,
                            rs: rs,
                        });
                        showDownload(type);
                    }, initLaunchRes, wx, wxLaunchFailedCallback)];
            case 1:
                _g.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.onClickJoinForDetail = onClickJoinForDetail;
/**
 * 任何页面可用
 * 点击加入会议前置判断 可判断是否安装会议app 可将onClickLaunchApp放入安装成功回调中
 * （使用示例见onClickJoinForDetail）
 * 若需要判断app安装状态 则根据判断结果执行installCb或uninstallCb
 * 若不需要判断 则执行defaultCb
 * @param checkInstall 是否需要判断安装状态 默认true
 * @param installCb 已安装回调
 * @param uninstallCb 未安装回调
 * @param defaultCb 默认回调
 * @param initLaunchRes （企业微信必须）初始化企业微信jsapi结果传入
 * @param wx （企业微信必须）企业微信jsapi
 * @returns
 */
var onClickLaunch = function (checkInstall, installCb, uninstallCb, defaultCb, initLaunchRes, wx, wxLaunchFailedCallback) {
    if (checkInstall === void 0) { checkInstall = true; }
    return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var ret;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!checkInstall) return [3 /*break*/, 3];
                    // 移动端微信是否安装app判断，不包括特邀会议逻辑,
                    if ((0, web_base_1.isMobile)() && (0, web_base_1.isWeChat)()) {
                        (0, tx_weixin_jsbridge_1.getInstallState)((0, web_base_1.isIOS)() ? 'iphone' : '', '', !!IS_I18N).then(function (res) {
                            console.log('>>>>>onClickLaunch getInstallState', res);
                            init_aegis_1.default.logAll('[met-component-launchapp]: >>>>>onClickLaunch getInstallState', res);
                            if (res) {
                                // 是否安装结果信息存在err_msg结构里
                                var msg = res.err_msg || '';
                                if (msg.indexOf('get_install_state:yes') >= 0) {
                                    installCb();
                                }
                                if (msg.indexOf('get_install_state:no') >= 0) {
                                    uninstallCb();
                                }
                                if (msg.indexOf('fail_no permission') >= 0) {
                                    installCb();
                                }
                                if (msg.indexOf('access_denied') >= 0) {
                                    wxLaunchFailedCallback === null || wxLaunchFailedCallback === void 0 ? void 0 : wxLaunchFailedCallback();
                                }
                            }
                        });
                        return [2 /*return*/, false];
                    }
                    if (!(initLaunchRes
                        && (0, web_base_1.isMobile)() && (0, web_base_1.isWxWork)() && !(0, web_base_1.isWxWorkLocal)()
                        && ((0, web_base_1.isAndroid)() || ((0, web_base_1.isIOS)() && (0, exports.isWxWorkGte312)())))) return [3 /*break*/, 3];
                    console.log('>>>onClickLaunch start');
                    ret = initLaunchRes;
                    if (!initLaunchRes.catch) return [3 /*break*/, 2];
                    return [4 /*yield*/, initLaunchRes.catch(function () { return null; })];
                case 1:
                    ret = _a.sent();
                    _a.label = 2;
                case 2:
                    console.log('--------await initLaunchRes--------', ret);
                    init_aegis_1.default.logAll('[met-component-launchapp]: >>>>>initLaunchRes', ret);
                    if (ret) { // 初始化成功
                        console.log('>>>> getInstallStateWxwork');
                        (0, tx_wxwork_jsbridge_1.getInstallStateWxwork)((0, web_base_1.isIOS)() ? 'iphone' : '').then(function (res) {
                            console.log('>>>>>getInstallStateWxwork', res);
                            init_aegis_1.default.logAll('[met-component-launchapp]: >>>>>getInstallStateWxwork', res);
                            if (res) {
                                // 是否安装结果信息存在err_msg结构里
                                var msg = res.is_installed || '';
                                if (msg) {
                                    installCb();
                                    return;
                                }
                                uninstallCb();
                            }
                        });
                        return [2 /*return*/, false];
                    }
                    /**
                     * 打印此log说明企业微信初始化jsapi出错！
                     */
                    wx && !wx.invoke && console.log('window.wx.invoke is undefined!!');
                    _a.label = 3;
                case 3:
                    // 不判断是否安装app则依次执行以下逻辑
                    console.log('>>>onClickLaunch defaultCb');
                    defaultCb();
                    return [2 /*return*/];
            }
        });
    });
};
exports.onClickLaunch = onClickLaunch;
/**
 * 启动腾讯会议
 * 微信环境里，不需要我们手动去加载jsapi，企业微信环境里，需要去加载jweixin-1.0.0.js
 * @param initLaunchRes （企业微信必须）初始化企业微信jsapi结果传入
 * @param {*} isWxWorkSaas Saas企业微信（非私有化企业微信）服务端方法
 * @param {WxLaunchFailedCallback} wxLaunchFailedCallback 微信唤起失败回调函数
 * @param {*} http http请求
 */
var onClickLaunchApp = function (props) {
    var type = props.type, meetingCode = props.meetingCode, meetingState = props.meetingState, meetingType = props.meetingType, joinToken = props.joinToken, initLaunchRes = props.initLaunchRes, showDetail = props.showDetail, defaultCb = props.defaultCb, customScheme = props.customScheme, meetingId = props.meetingId, showDownload = props.showDownload, beaconReport = props.beaconReport, wxLaunchFailedCallback = props.wxLaunchFailedCallback, queryLaunchTimeout = props.queryLaunchTimeout, http = props.http, aegis = props.aegis, _a = props.from, from = _a === void 0 ? '' : _a, rs = props.rs;
    var wtoken = (0, web_base_1.getRequest)('wtoken');
    var joinMode = Number((0, web_base_1.getRequest)('mode') || 0);
    var launchId = (0, web_base_1.randomString)(16);
    var launchMode = Number((0, web_base_1.getRequest)('launch-mode') || enum_1.EnumLaunchMode.NotValid);
    var isPmi = (0, web_base_1.getRequest)('isPmi');
    console.log('>>> onClickLaunchApp:', meetingState);
    init_aegis_1.default.logAll("[met-component-launchapp]onClickLaunchApp start type: ".concat(type, " meetingState: ").concat(meetingState));
    var launchParams = {
        initLaunchRes: initLaunchRes,
        // isVoov: IS_I18N, todo
        schemeUrl: customScheme
            || (0, get_scheme_1.getSchemeUrl)(type, meetingCode, joinToken, wtoken, launchMode, meetingType, launchId, meetingId),
        launchId: launchId,
        meetingType: meetingType,
        launchMode: launchMode,
        logId: (0, web_base_1.randomString)(15),
        defaultLogic: {
            fail: function () {
                defaultCb();
                init_aegis_1.default.logAll('[met-component-launchapp]onClickLaunchApp defaultLogic go to fail logic');
            },
            jumpCallback: function (resultMsg) {
                // 引导打开app入会
                if (resultMsg.indexOf('fail_no permission') > -1 || resultMsg.indexOf('access_denied') > -1) {
                    wxLaunchFailedCallback === null || wxLaunchFailedCallback === void 0 ? void 0 : wxLaunchFailedCallback();
                    beaconReport('web_launchapp_event_null_null_null_null_result', { fromSource: from, result: 0 });
                }
            },
            reportCallback: beaconReport,
        },
        launchCallback: {
            success: function (startTime) {
                var currentTime = new Date();
                beaconReport('web_launchapp_event_null_null_null_null_result', {
                    sense_time: Math.floor((Number(currentTime) - startTime) / 1000),
                    meeting_code: meetingCode,
                    meeting_state: meetingState,
                    user_agent: navigator.userAgent,
                    is_launching_app: 0,
                    is_pmi: isPmi ? 1 : 0,
                    launch_from: launchFrom(meetingType, launchMode),
                    fromSource: from,
                    result: 1,
                });
                init_aegis_1.default.logAll('[met-component-launchapp]onClickLaunchApp launch_app_succ');
                if (meetingType === enum_1.EnumMeetingType.SpeciallyInvitedMeeting) {
                    return false;
                }
                if (joinMode === 1) {
                    return false;
                }
                /**
                 * 回调成功重新展示详情页
                 */
                showDetail();
            },
            fail: function (startTime) {
                var currentTime = new Date();
                beaconReport('web_launchapp_event_null_null_null_null_result', {
                    time_past: Math.floor((currentTime - startTime) / 1000),
                    meeting_code: meetingCode,
                    meeting_state: meetingState,
                    user_agent: navigator.userAgent,
                    is_launching_app: 0,
                    is_pmi: isPmi ? 1 : 0,
                    launch_from: launchFrom(meetingType, launchMode),
                    fromSource: from,
                    result: 0,
                });
                init_aegis_1.default.logAll('[met-component-launchapp]onClickLaunchApp launch_app_fail');
                var pcJoinSpecLogic = (0, web_base_1.getRequest)('pcJoinSpecLogic');
                if (pcJoinSpecLogic) {
                    showDownload();
                    var curTime = (new Date()).getTime() / 1000;
                    var meetingBeginTime = (0, web_base_1.getRequest)('meetingBeginTime');
                    beaconReport('meetingdetail_null_null_null_null_null_open_tm_timeout', {
                        start_time: meetingBeginTime,
                        if_beforemeeting: (Number(meetingBeginTime) - curTime) > 0,
                    });
                }
            },
        },
        queryLaunchTimeout: queryLaunchTimeout,
        http: http,
        isWxWorkSaas: function () { return (0, web_base_1.isWxWork)() && !(0, web_base_1.isWxWorkLocal)(); },
        aegis: aegis,
        rs: rs,
    };
    (0, launch_app_1.launchApp)(launchParams);
};
exports.onClickLaunchApp = onClickLaunchApp;
/**
* 唤起app方式
* 1=普通会议，2=周期性会议，3=PMI，4=特邀会议邀请，5=特邀会议入会
*/
var launchFrom = function (meetingType, launchMode) {
    // 默认普通会议
    var launchFrom = enum_1.EnumLaunchFrom.NormalMeeting;
    if (meetingType) {
        // 周期性会议
        if (meetingType === enum_1.EnumMeetingType.PeriodicalMeeting) {
            launchFrom = enum_1.EnumLaunchFrom.PeriodicalMeeting;
        }
        // 特邀会议
        if (meetingType === enum_1.EnumMeetingType.SpeciallyInvitedMeeting) {
            // 扫码
            if (launchMode === enum_1.EnumLaunchMode.QrCode) {
                launchFrom = enum_1.EnumLaunchFrom.QrCode;
            }
            // 小程序、公众号push
            if (launchMode === enum_1.EnumLaunchMode.MiniProgram) {
                launchFrom = enum_1.EnumLaunchFrom.MiniProgram;
            }
        }
    }
    return launchFrom;
};
//# sourceMappingURL=trigger-launch.js.map